// Tab controller (vanilla JS, replaces jQuery version from WP theme)
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tab a").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()
      const tabItem = link.parentElement
      const tabList = tabItem?.parentElement
      const tabContentsId = link.getAttribute("href")
      if (!tabList || !tabContentsId) return

      tabList.querySelectorAll("li.active").forEach((el) => el.classList.remove("active"))
      tabItem.classList.add("active")

      const container = tabList.closest(".inner-container") || document
      container.querySelectorAll(".tabContents.active").forEach((el) => el.classList.remove("active"))
      const target = container.querySelector(tabContentsId)
      target?.classList.add("active")
    })
  })

  if (typeof ScrollHint !== "undefined") {
    new ScrollHint(".js-scrollable", {
      suggestiveShadow: true,
      i18n: {
        scrollable: "スクロールできます",
      },
    })
  }
})
